<template>
  <div
    ref="chart"
    style="height: 100%; width: 100%"
  />
</template>

<script>
import Plotly from 'plotly.js-cartesian-dist-min'

export default {
  name: 'PieChart',

  props: {
    data: Object, // { labels: Array, values: Array }
    seriesName: String,
    title: String,
    radius: String,
    showLegend: {
      type: Boolean,
      default: false
    },
    showDownload: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    pieData () {
      return [{
        values: (this.data && this.data.values) || [],
        labels: (this.data && this.data.labels) || [],
        type: 'pie'
      }]
    },

    pieLayout () {
      return {
        title: this.seriesName || ''
      }
    }
  },

  watch: {
    pieData: {
      handler () {
        this.loadChart()
      },
      deep: true
    },

    pieLayout: {
      handler () {
        this.loadChart()
      },
      deep: true
    }
  },

  mounted () {
    this.loadChart()
  },

  methods: {
    /**
     * Loads the pie chart
     */
    loadChart () {
      const { chart } = this.$refs

      Plotly.newPlot(chart, this.pieData, this.pieLayout, { responsive: true })
    }
  }
}
</script>
